var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.isButton ? _c('v-layout', {
    staticClass: "caption",
    attrs: {
      "row": "",
      "justify-center": "",
      "mt-3": ""
    }
  }, [_vm._v("\n    or  \n    "), _c('a', {
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.abortVisit')))])]) : _vm._e(), _vm.isButton ? _c('v-btn', {
    attrs: {
      "color": "warning"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.abortVisit')))]) : _vm._e(), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.abortVisitConfirmation')))]), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.abortVisitConfirmationText')) + "\n      ")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.cancel')) + "\n        ")]), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        return _vm.abortVisit();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.yesAbortVisit')) + "\n        ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }